import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { AGENCIES_ENDPOINT, getBaseUrl } from '../../constants';

/**
 * Creates a new Application.
 * @agencies
 */
export class Agencies {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Agencies(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.endpoint = AGENCIES_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }
  /**
   * this function is to get all agencies
   * @function getAllAgencies
   ** @param {reqParam} default parameter
   */

  async getAllAgencies(reqParam) {
    const queryString = queryBuilder(reqParam);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async getAgencyById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async putAgencyById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, req.reqBody);
    return response?.data;
  }

  async postAgency(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async deleteAgencyById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }
}

export const createAgencies = () => Agencies.getInstance();
